module.exports = __webpack_public_path__ + "img/dashboardTour6.3300f60d.svg";